import * as Yup from "yup";

import { Form, Spinner } from "react-bootstrap";
import TableActionButton from "../../../@ui/TableActionButton";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";
import { Formik } from "formik";
import { usePurchaseLicenceContext } from "../../../context/PurchaseLicence/PurchaseLicenceContext";

interface ConcurrentFooterProps {
  licence: LicenceTypePurchase;
}

const schema = Yup.object().shape({
  numberOfUsers: Yup.string().required("Users is required"),
});

const ConcurrentFooter = ({ licence }: ConcurrentFooterProps) => {
  const { onPurchaseLicence, loading } = usePurchaseLicenceContext();

  const initialValues = {
    numberOfUsers: "",
  };

  const onSubmit = (values: any) => {
    onPurchaseLicence(licence.softwareLicenceId, values.numberOfUsers);
  };

  return (
    <>
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-1">
              <Form.Label className="mb-0">Number of users:</Form.Label>
              <Form.Control
                type="input"
                onChange={handleChange}
                value={values.numberOfUsers}
                isInvalid={touched.numberOfUsers && !!errors.numberOfUsers}
                onBlur={handleBlur}
                name="numberOfUsers"
              />
              <Form.Control.Feedback type="invalid">
                {errors.numberOfUsers}
              </Form.Control.Feedback>
            </Form.Group>
            <TableActionButton type="submit" style={{ width: "100%" }}>
              {loading ? <Spinner animation="border" /> : "Purchase"}
              Purchase
            </TableActionButton>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ConcurrentFooter;
